var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PageHeader',{attrs:{"title":_vm.nameTitle,"items":_vm.headerItems}}),_c('StatusBar',{staticClass:"team-task-detail-status-bar",attrs:{"transitions":_vm.transitions},on:{"updateStatus":function($event){return _vm.updateStatus($event)}}}),_c('div',{staticClass:"mt-4"},[_c('ReadOnly',{attrs:{"componentData":_vm.readonlyData}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }